import { z } from 'zod';

import { ReportableEventId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const DeleteReportableEventEvent = BaseLoanEvent.extend({
  type: z.literal('deleteReportableEvent'),
  reportableEventId: ReportableEventId,
});
export type DeleteReportableEventEvent = z.infer<typeof DeleteReportableEventEvent>;
